import { Factory } from './Factory'
export class HeaderFactory extends Factory {
  constructor() {
    super()
  }

  create() {
    return this.buildHeader()
  }

  buildHeader() {
    return {
      id: this.id('header'),
      ctaId: this.id('header-cta'),
      logoId: this.id('header-logo'),
      containerId: this.id('header-container'),
      background: {
        desktop: 'color',
        tablet: 'color',
        phone: 'color'
      },
      assets: {
        desktop: [],
        tablet: [],
        phone: []
      },
      containerClasses: {
        desktop: [
          {property: 'Shadow', value: 'SHADOW_MD'},
          {property: 'PaddingTop', value: 'PADDING_TOP_XS'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_XS'},
          {property: 'BorderStyle', value: 'BORDER_SOLID'},
          {property: 'BorderSideTopWidth', value: 'BORDER_TOP_BOLDER'},
          {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_0'},
          {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_0'},
          {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_0'},
        ],
        tablet: [
          {property: 'Shadow', value: 'SHADOW_MD'},
          {property: 'PaddingTop', value: 'PADDING_TOP_XS'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_XS'},
          {property: 'BorderStyle', value: 'BORDER_SOLID'},
          {property: 'BorderSideTopWidth', value: 'BORDER_TOP_BOLDER'},
          {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_0'},
          {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_0'},
          {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_0'},
        ],
        phone: [
          {property: 'Shadow', value: 'SHADOW_MD'},
          {property: 'PaddingTop', value: 'PADDING_TOP_XS'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_XS'},
          {property: 'BorderStyle', value: 'BORDER_SOLID'},
          {property: 'BorderSideTopWidth', value: 'BORDER_TOP_BOLDER'},
          {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_0'},
          {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_0'},
          {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_0'},
        ]
      },
      containerNavLinkClasses: {
        desktop: [
          {property: 'SpaceHorizontal', value : 'SPACE_SSM'}
        ],
        tablet: [
          {property: 'SpaceHorizontal', value : 'SPACE_SSM'}
        ],
        phone: [
          {property: 'SpaceHorizontal', value : 'SPACE_SSM'}
        ]
      },
      navLinkClasses: {
        desktop: [
          {property: 'FontSize', value: 'FONT_SIZE_SM'},
          {property: 'FontWeight', value: 'BOLD'},
          {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
        ],
        tablet: [
          {property: 'FontSize', value: 'FONT_SIZE_SM'},
          {property: 'FontWeight', value: 'BOLD'},
          {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
        ],
        phone: [
          {property: 'FontSize', value: 'FONT_SIZE_SM'},
          {property: 'FontWeight', value: 'BOLD'},
          {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
        ]
      },
      navLinkStyles: {
        desktop: [],
        tablet: [],
        phone: []
      },
      megaMenuTitleClasses: {
        desktop: [
          {property:'FontSize', value:'FONT_SIZE_BASE'},
          {property:'TextAlignment', value:'LEFT'},
          {property:'Rounded', value:'ROUNDED_SM'},
          {property:'FontWeight', value:'BOLD'},
          {property:'BorderStyle', value:'BORDER_SOLID'},
          {property:'PaddingTop', value:'PADDING_TOP_NONE'},
          {property:'PaddingBottom', value:'PADDING_BOTTOM_XXXS'},
          {property:'PaddingLeft', value:'PADDING_LEFT_NONE'},
          {property:'PaddingRight', value:'PADDING_RIGHT_NONE'},
          {property:'BorderSideTopWidth', value:'BORDER_TOP_0'},
          {property:'BorderSideBottomWidth', value:'BORDER_BOTTOM_NORMAL'},
          {property:'BorderSideRightWidth', value:'BORDER_RIGHT_0'},
          {property:'BorderSideLeftWidth', value:'BORDER_LEFT_0'}
        ],
        tablet: [
          {property:'FontSize', value:'FONT_SIZE_BASE'},
          {property:'TextAlignment', value:'LEFT'},
          {property:'Rounded', value:'ROUNDED_SM'},
          {property:'FontWeight', value:'BOLD'},
          {property:'BorderStyle', value:'BORDER_SOLID'},
          {property:'PaddingTop', value:'PADDING_TOP_NONE'},
          {property:'PaddingBottom', value:'PADDING_BOTTOM_XXXS'},
          {property:'PaddingLeft', value:'PADDING_LEFT_NONE'},
          {property:'PaddingRight', value:'PADDING_RIGHT_NONE'},
          {property:'BorderSideTopWidth', value:'BORDER_TOP_0'},
          {property:'BorderSideBottomWidth', value:'BORDER_BOTTOM_NORMAL'},
          {property:'BorderSideRightWidth', value:'BORDER_RIGHT_0'},
          {property:'BorderSideLeftWidth', value:'BORDER_LEFT_0'}
        ],
        phone: [
          {property:'FontSize', value:'FONT_SIZE_BASE'},
          {property:'TextAlignment', value:'LEFT'},
          {property:'Rounded', value:'ROUNDED_SM'},
          {property:'FontWeight', value:'BOLD'},
          {property:'BorderStyle', value:'BORDER_SOLID'},
          {property:'PaddingTop', value:'PADDING_TOP_NONE'},
          {property:'PaddingBottom', value:'PADDING_BOTTOM_XXXS'},
          {property:'PaddingLeft', value:'PADDING_LEFT_NONE'},
          {property:'PaddingRight', value:'PADDING_RIGHT_NONE'},
          {property:'BorderSideTopWidth', value:'BORDER_TOP_0'},
          {property:'BorderSideBottomWidth', value:'BORDER_BOTTOM_NORMAL'},
          {property:'BorderSideRightWidth', value:'BORDER_RIGHT_0'},
          {property:'BorderSideLeftWidth', value:'BORDER_LEFT_0'}
        ]
      },
      megaMenuTitleStyles: {
        desktop: [
          {property:'TextColor', styleProperty:'color', value:'rgba(119, 118, 192, 1)'},
          {property:'BorderColor', styleProperty:'border-color', value:'rgba(119, 118, 192, 1)'}
        ],
        tablet: [
          {property:'TextColor', styleProperty:'color', value:'rgba(119, 118, 192, 1)'},
          {property:'BorderColor', styleProperty:'border-color', value:'rgba(119, 118, 192, 1)'}
        ],
        phone: [
          {property:'TextColor', styleProperty:'color', value:'rgba(119, 118, 192, 1)'},
          {property:'BorderColor', styleProperty:'border-color', value:'rgba(119, 118, 192, 1)'}
        ]
      },
      megaMenuContainerClasses: {
        desktop: [
          {property:'Shadow', value:'SHADOW_LG'},
          {property:'Rounded', value:'ROUNDED_LG'},
          {property:'PaddingTop', value:'PADDING_TOP_XS'},
          {property:'PaddingBottom', value:'PADDING_BOTTOM_XS'},
          {property:'PaddingLeft', value:'PADDING_LEFT_XS'},
          {property:'PaddingRight', value:'PADDING_RIGHT_XS'},
          {property:'MarginTop', value:'MARGIN_TOP_XS'},
          {property:'MarginBottom', value:'MARGIN_BOTTOM_NONE'},
          {property:'MarginLeft', value:'MARGIN_LEFT_NONE'},
          {property:'MarginRight', value:'MARGIN_RIGHT_NEGATIVE_SM'},
          {property:'BorderStyle', value:'BORDER_SOLID'},
          {property:'BorderSideTopWidth', value:'BORDER_TOP_THIN'},
          {property:'BorderSideBottomWidth', value:'BORDER_BOTTOM_THIN'},
          {property:'BorderSideRightWidth', value:'BORDER_RIGHT_THIN'},
          {property:'BorderSideLeftWidth', value:'BORDER_LEFT_THIN'}
        ],
        tablet: [
          {property:'Shadow', value:'SHADOW_LG'},
          {property:'Rounded', value:'ROUNDED_LG'},
          {property:'PaddingTop', value:'PADDING_TOP_XS'},
          {property:'PaddingBottom', value:'PADDING_BOTTOM_XS'},
          {property:'PaddingLeft', value:'PADDING_LEFT_XS'},
          {property:'PaddingRight', value:'PADDING_RIGHT_XS'},
          {property:'MarginTop', value:'MARGIN_TOP_XS'},
          {property:'MarginBottom', value:'MARGIN_BOTTOM_NONE'},
          {property:'MarginLeft', value:'MARGIN_LEFT_NONE'},
          {property:'MarginRight', value:'MARGIN_RIGHT_NONE'},
          {property:'BorderStyle', value:'BORDER_SOLID'},
          {property:'BorderSideTopWidth', value:'BORDER_TOP_THIN'},
          {property:'BorderSideBottomWidth', value:'BORDER_BOTTOM_THIN'},
          {property:'BorderSideRightWidth', value:'BORDER_RIGHT_THIN'},
          {property:'BorderSideLeftWidth', value:'BORDER_LEFT_THIN'}
        ],
        phone: [
          {property:'Shadow', value:'SHADOW_LG'},
          {property:'Rounded', value:'ROUNDED_LG'},
          {property:'PaddingTop', value:'PADDING_TOP_XS'},
          {property:'PaddingBottom', value:'PADDING_BOTTOM_XS'},
          {property:'PaddingLeft', value:'PADDING_LEFT_XS'},
          {property:'PaddingRight', value:'PADDING_RIGHT_XS'},
          {property:'MarginTop', value:'MARGIN_TOP_XS'},
          {property:'MarginBottom', value:'MARGIN_BOTTOM_NONE'},
          {property:'MarginLeft', value:'MARGIN_LEFT_NONE'},
          {property:'MarginRight', value:'MARGIN_RIGHT_NONE'},
          {property:'BorderStyle', value:'BORDER_SOLID'},
          {property:'BorderSideTopWidth', value:'BORDER_TOP_THIN'},
          {property:'BorderSideBottomWidth', value:'BORDER_BOTTOM_THIN'},
          {property:'BorderSideRightWidth', value:'BORDER_RIGHT_THIN'},
          {property:'BorderSideLeftWidth', value:'BORDER_LEFT_THIN'}
        ]
      },
      megaMenuContainerStyles: {
        desktop: [
          {property:'WidthStyle', styleProperty:'width', value:'560px'},
          {property:'BorderColor', styleProperty:'border-color', value:'rgba(203, 213, 224, 1)'},
          {property:'BackgroundColor', styleProperty:'background-image', value:'linear-gradient(0deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1))'}
        ],
        tablet: [
          {property:'WidthStyle', styleProperty:'width', value:'560px'},
          {property:'BorderColor', styleProperty:'border-color', value:'rgba(203, 213, 224, 1)'},
          {property:'BackgroundColor', styleProperty:'background-image', value:'linear-gradient(0deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1))'}
        ],
        phone: [
          {property:'WidthStyle', styleProperty:'width', value:'560px'},
          {property:'BorderColor', styleProperty:'border-color', value:'rgba(203, 213, 224, 1)'},
          {property:'BackgroundColor', styleProperty:'background-image', value:'linear-gradient(0deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1))'}
        ]
      },
      megaMenuClasses: {
        desktop: [
          {property: 'SpaceVertical', value: 'SPACE_XS'}
        ],
        tablet: [
          {property: 'SpaceVertical', value: 'SPACE_XS'}
        ],
        phone: [
          {property: 'SpaceVertical', value: 'SPACE_XS'}
        ]
      },
      megaMenuStyles: {
        desktop: [],
        tablet: [],
        phone: []
      },
      subMenuClasses: {
        desktop: [],
        tablet: [],
        phone: []
      },
      subMenuStyles: {
        desktop: [],
        tablet: [],
        phone: []
      },
      subMenuContainerClasses: {
        desktop: [],
        tablet: [],
        phone: []
      },
      subMenuContainerStyles: {
        desktop: [],
        tablet: [],
        phone: []
      },
      ctaClasses: {
        desktop: [
          {property: 'FontSize', value: 'FONT_SIZE_SM'},
          {property: 'FontWeight', value: 'BOLD'},
          {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
        ],
        tablet: [
          {property: 'FontSize', value: 'FONT_SIZE_SM'},
          {property: 'FontWeight', value: 'BOLD'},
          {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
        ],
        phone: [
          {property: 'FontSize', value: 'FONT_SIZE_SM'},
          {property: 'FontWeight', value: 'BOLD'},
          {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
        ]
      },
      ctaStyles: {
        desktop: [],
        tablet: [],
        phone: []
      },
      hoverCtaClasses: {
        desktop: [],
        tablet: [],
        phone: []
      },
      hoverCtaStyles: {
        desktop: [],
        tablet: [],
        phone: []
      },
      hoverNavLinkClasses: {
        desktop: [],
        tablet: [],
        phone: []
      },
      hoverNavLinkStyles: {
        desktop: [],
        tablet: [],
        phone: []
      },
      classes: {
        desktop: [
          {property: 'Container', value: 'CONTAINER_TRUE'},
        ],
        tablet: [
          {property: 'Container', value: 'CONTAINER_TRUE'},
        ],
        phone: [
          {property: 'Container', value: 'CONTAINER_TRUE'},
        ]
      },
      styles: {
        desktop: [
          {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #ffffff,#ffffff)'},
          {property:'BorderColor', styleProperty: 'border-color', value: '#5244cc'}
        ],
        tablet: [
          {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #ffffff,#ffffff)'},
          {property:'BorderColor', styleProperty: 'border-color', value: '#5244cc'}
        ],
        phone: [
          {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #ffffff,#ffffff)'},
          {property:'BorderColor', styleProperty: 'border-color', value: '#5244cc'}
        ]
      },
      content: {
        type: 'DEFAULT',
        logo: '',
        hasCTA: true,
        megaMenuFullWidth: false,
        ctaText: 'Join now',
        ctaLink: '#',
        navLinks: [
          {
            text: 'Home',
            link: 'https://webforcehq.com',
            target: '_self',
            children: [
              {
                text: 'Products',
                link: 'https://webforcehq.com/features',
                target: '_self',
                children: [
                  {
                    text: 'Products 1',
                    link: 'https://webforcehq.com/features',
                    target: '_self',
                    children: []
                  },
                  {
                    text: 'Products 2',
                    link: 'https://webforcehq.com/features',
                    target: '_self',
                    children: []
                  },
                  {
                    text: 'Products 3',
                    link: 'https://webforcehq.com/features',
                    target: '_self',
                    children: []
                  },
                ]
              },
              {
                text: 'Services',
                link: 'https://webforcehq.com/features',
                target: '_self',
                children: [
                  {
                    text: 'Services 1',
                    link: 'https://webforcehq.com/features',
                    target: '_self',
                    children: []
                  },
                  {
                    text: 'Services 2',
                    link: 'https://webforcehq.com/features',
                    target: '_self',
                    children: []
                  },
                  {
                    text: 'Services 3',
                    link: 'https://webforcehq.com/features',
                    target: '_self',
                    children: []
                  },
                ]
              },
            ]
          },
          {
            text: 'Features',
            link: 'https://webforcehq.com/features',
            target: '_self',
            children: []
          },
          {
            text: 'Contact',
            link: 'https://webforcehq.com/contact',
            target: '_self',
            children: []
          },
          {
            text: 'About us',
            link: 'https://webforcehq.com/about-us',
            target: '_self',
            children: []
          },
        ]
      },
      properties: {
        content: [
          {key: 'header-type', component:'ContentHeaderType'},
          {key: 'nav-links', component:'ContentNavLinks'},
          {key: 'has-cta', component:'ContentToggle', text:'CTA', property: 'hasCTA'},
          {key: 'cta-text', component:'ContentText', text:'CTA Text', property: 'ctaText'},
          { key: 'cta-link', component: 'ContentText', text: 'CTA Link', property: 'ctaLink' },
          {key: 'full-width-mega-menu', component:'ContentToggle', text:'Full width Megamenu', property: 'megaMenuFullWidth'},
        ],
        style: [
          {key: 'container', component:'ContainerProperty'},
          {key: 'fixed', component: 'FixedProperty', class: 'containerClasses'},
          {key: 'background-color', component:'BackgroundProperty', only: ['color'], class: 'containerClasses'},
          {key: 'border', component:'BorderProperty', class: 'containerClasses'},
          {key: 'padding', component:'PaddingProperty', class: 'containerClasses'},
          {key: 'shadow', component:'ShadowProperty', class: 'containerClasses'},
        ],
        navStyles: [
          {key: 'space-x', component: 'SpaceHorizontalProperty', class: 'containerNavLinkClasses'},
          {key: 'background-color', component:'BackgroundProperty', styles:'navLinkStyles', only: ['color']},
          {key: 'background-hover-color', component:'BackgroundProperty', styles:'hoverNavLinkStyles', class: 'hoverNavLinkClasses', only: ['color'], text: 'background hover color'},
          {key: 'text-color', component:'TextColorProperty', styles:'navLinkStyles'},
          {key: 'text-hover-color', component:'TextColorProperty', styles:'hoverNavLinkStyles', text: 'text hover color'},
          {key: 'shadow', component: 'ShadowProperty', class: 'navLinkClasses'},
          {key: 'rounded', component: 'RoundedProperty', class: 'navLinkClasses'},
          {key: 'font-size', component: 'FontSizeProperty', class: 'navLinkClasses'},
          {key: 'font-weight', component: 'FontWeightProperty', class: 'navLinkClasses'},
          {key: 'padding', component: 'PaddingProperty', class: 'navLinkClasses'},
          {key: 'border', component: 'BorderProperty', class: 'navLinkClasses', styles:'navLinkStyles'},
        ],
        ctaStyles: [
          {key: 'background-color', component:'BackgroundProperty', styles:'ctaStyles', only: ['color']},
          {key: 'background-hover-color', component:'BackgroundProperty', styles:'hoverCtaStyles', class: 'hoverCtaClasses', only: ['color'], text: 'background hover color'},
          {key: 'text-color', component:'TextColorProperty', styles:'ctaStyles'},
          {key: 'text-hover-color', component:'TextColorProperty', styles:'hoverCtaStyles', text: 'text hover color'},
          {key: 'shadow', component: 'ShadowProperty', class: 'ctaClasses'},
          {key: 'rounded', component: 'RoundedProperty', class: 'ctaClasses'},
          {key: 'font-size', component: 'FontSizeProperty', class: 'ctaClasses'},
          {key: 'font-weight', component: 'FontWeightProperty', class: 'ctaClasses'},
          {key: 'padding', component: 'PaddingProperty', class: 'ctaClasses'},
          {key: 'border', component: 'BorderProperty', class: 'ctaClasses', styles:'ctaStyles'},
        ],
        subMenuStyles: [
          {key: 'text-alignment', component: 'TextAlignmentProperty', class: 'subMenuContainerClasses',},
          {key: 'space-y', component: 'SpaceVerticalProperty', class: 'subMenuClasses'},
          {key: 'width', component: 'CustomWidthProperty', styles: 'subMenuContainerStyles'},
          {key: 'background-color', component:'BackgroundProperty', styles:'subMenuContainerStyles', only: ['color']},
          {key: 'text-color', component:'TextColorProperty', styles:'subMenuContainerStyles'},
          {key: 'shadow', component: 'ShadowProperty', class: 'subMenuContainerClasses'},
          {key: 'rounded', component: 'RoundedProperty', class: 'subMenuContainerClasses'},
          {key: 'font-size', component: 'FontSizeProperty', class: 'subMenuContainerClasses'},
          {key: 'font-weight', component: 'FontWeightProperty', class: 'subMenuContainerClasses'},
          {key: 'padding', component: 'PaddingProperty', class: 'subMenuContainerClasses'},
          {key: 'margin', component: 'MarginProperty', class: 'subMenuContainerClasses'},
          {key: 'border', component: 'BorderProperty', class: 'subMenuContainerClasses', styles:'subMenuContainerStyles'},
        ],
        megaMenuStyles: [
          {key: 'space-y', component: 'SpaceVerticalProperty', class: 'megaMenuClasses'},
          {key: 'width', component: 'CustomWidthProperty', styles: 'megaMenuContainerStyles'},
          {key: 'background-color', component:'BackgroundProperty', styles:'megaMenuContainerStyles', only: ['color']},
          {key: 'text-alignment', component: 'TextAlignmentProperty', class: 'megaMenuClasses',},
          {key: 'text-color', component:'TextColorProperty', styles:'megaMenuStyles', text: 'link color'},
          {key: 'shadow', component: 'ShadowProperty', class: 'megaMenuContainerClasses'},
          {key: 'rounded', component: 'RoundedProperty', class: 'megaMenuContainerClasses'},
          {key: 'font-size', component: 'FontSizeProperty', class: 'megaMenuClasses'},
          {key: 'font-weight', component: 'FontWeightProperty', class: 'megaMenuClasses'},
          {key: 'padding', component: 'PaddingProperty', class: 'megaMenuContainerClasses'},
          {key: 'margin', component: 'MarginProperty', class: 'megaMenuContainerClasses'},
          {key: 'border', component: 'BorderProperty', class: 'megaMenuContainerClasses', styles:'megaMenuContainerStyles'},
        ],
        megaMenuTitleStyles: [
          {key: 'text-alignment', component: 'TextAlignmentProperty', class: 'megaMenuTitleClasses',},
          {key: 'background-color', component:'BackgroundProperty', styles:'megaMenuTitleStyles', only: ['color']},
          {key: 'rounded', component: 'RoundedProperty', class: 'megaMenuTitleClasses'},
          {key: 'font-size', component: 'FontSizeProperty', class: 'megaMenuTitleClasses'},
          {key: 'font-weight', component: 'FontWeightProperty', class: 'megaMenuTitleClasses'},
          {key: 'text-color', component:'TextColorProperty', styles:'megaMenuTitleStyles', text: 'text color'},
          {key: 'border', component: 'BorderProperty', class: 'megaMenuTitleClasses', styles:'megaMenuTitleStyles'},
          {key: 'padding', component: 'PaddingProperty', class: 'megaMenuTitleClasses'},
        ]
      }
    }
  }
}